// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__r+XTQ","slide":"Slider_slide__jz9Iv","mask":"Slider_mask__otAhm"};